import { gql } from "@apollo/client";

const deleteCustomsShipmentPalletCartonMutation = gql`
  mutation ($customsShipmentPalletCartonId: ID!) {
    deleteCustomsShipmentPalletCarton(
      customsShipmentPalletCartonId: $customsShipmentPalletCartonId
    ) {
      errors {
        customsShipmentPalletCartonId
      }
      succeeded
    }
  }
`;

export default deleteCustomsShipmentPalletCartonMutation;
